import type { IValidationField } from 'hooks/useValidations/types';
import { t } from 'i18next';
import * as yup from 'yup';

export default function seedQuantity({ label = '', context = {} }: IValidationField) {
  const { min, max } = context;

  let validation = yup
    .number()
    .label(label)
    .typeError(`${label} ${t('errors.number')}`)
    .min(min)
    .when('packageReference', {
      is: (val: boolean) => val,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema,
    })
    .positive()
    .test({
      name: 'greater_than_min',
      test: (value, context) => {
        if (value === undefined) return true;
        if (value < min) {
          return context.createError({
            message: t('errors.greaterThanOrEqualTo', { label, value: min }),
          });
        }
        return true;
      },
    });

  if (max) validation = validation.max(max);
  return validation;
}
